import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("debug-pill__div-3jf7xp", {
  backgroundColor: "var(--system-success)",
  borderRadius: "1000px",
  padding: "8px 16px",
  fontSize: "13px",
  fontWeight: "500",
  color: "white",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.1)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "all 0.2s ease",
  userSelect: "none",
  whiteSpace: "nowrap",
  zIndex: "100",
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2), 0 2px 4px rgba(0, 0, 0, 0.15)"
  },
  "&:active": {
    transform: "translateY(0)",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.15)"
  },
  "@media (max-width: 768px)": {
    padding: "10px 18px",
    fontSize: "14px",
    minWidth: "120px"
  }
});
import React from 'react';
import { colors } from '../colors';
const DebugPill = React.forwardRef<HTMLDivElement, HtmlPropsNoRef<HTMLDivElement>>((props, ref) => <div {..._mergeProps({
  ref: ref,
  css: _staticStyles
}, props)} />);
DebugPill.displayName = 'DebugPill';
export default DebugPill;